/**
 * 全局配置文件
 */

// 服务器配置
export const SERVER_CONFIG = {
  // 服务器基础URL
  BASE_URL: 'http://life-travel.cn:88',
  
  // 密钥分享页面路径
  KEY_SHARING_PATH: '/simple.html',
  
  // 密钥访问路径
  KEY_ACCESS_PATH: '#/access/'
};

// 加密配置
export const CRYPTO_CONFIG = {
  // 加密密钥
  ENCRYPTION_KEY: 'life-travel-encryption-key-2025'
};

export default {
  SERVER_CONFIG,
  CRYPTO_CONFIG
};